import Layout from "@/components/elements/Layout";
import Link from "next/link";

export default function CancellationPolicy() {
  return (
    <Layout title={"Cancellation Policy"}>
      <div className='py-8 mx-auto prose lg:py-16'>
        <h1 className='mb-0 text-6xl font-bold leading-tight text-white font-display'>
          Cancellation Policy
        </h1>
        <p className='text-white text-opacity-80'>
          Effective Date: July 1st, 2022
        </p>
        <div className='max-w-screen-xl py-8'>
          <article className='prose prose-invert pb-8 prose-img:rounded-[10px] prose-td:p-2 max-w-5xl'>
            <p>
              We do not provide subscription refunds for Lucidity Insights
              products. But, if you are unsatisfied with our products, you can
              terminate any future subscriptions for future months or years.
            </p>
            <p>
              If, and only if, you have purchased an annual package within the
              past 7 days, and have not accessed any locked content, you can
              send a special cancellation request to
              billing@lucidityinsights.com within 7 days of your subscription
              beginning and we will review on a case by case basis, to help you
              terminate your subscription early and get a partial refund. If any
              locked content was accessed, no refunds will be issued.
            </p>
            <p>
              If you would like to cancel your subscription, go to ‘My Account’
              and select ‘My Plan’ under ‘Subscriptions’. You can “Stop
              Subscription” there. This will cancel only future charges
              associated with your subscription. Cancellations are effective at
              the end of the current billing period, and as such, Lucidity
              Insights does not offer prorated refunds for cancelled
              subscriptions. All subscriptions are recurring and will
              automatically renew after the end of each paid subscription
              period. You will not receive a refund for the current billing
              cycle as you will continue to have the same access and benefits of
              your subscription for the remainder of the current billing period.
            </p>
            <p>
              Lucidity Insights is also free to terminate (or suspend access to)
              your use of your subscription or your account, for any reason in
              our discretion, including a breach of our{" "}
              <Link legacyBehavior href='/terms-of-service' passHref>
                <a>Terms of Service</a>
              </Link>
              . Lucidity Insights has the sole right to decide whether you are
              in violation of any of the restrictions set forth in these Terms.
              You will not be entitled to a refund in these circumstances.
            </p>
            <p>
              We reserve the right to issue refunds or credits at our sole
              discretion. If we issue a refund or credit, we are under no
              obligation to issue the same or similar refund in the future.
            </p>
          </article>
        </div>
      </div>
    </Layout>
  );
}
